import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { Message, OverlayPanel, SelectItem } from 'primeng/primeng';

//constants

import * as enums from '../../enums/index'
import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as util from '../../util/index'

//validators
import { dropDownValidator } from '../../validators/CustomValidators';
import { hiddenDropDownValueValidator } from '../../validators/CustomValidators';
import { postalCodeValidator } from '../../validators/CustomValidators';

//components
import { StateDropdownComponent } from '../../components/DomainData/StateDropdown.component';
import { MapComponent } from '../../components/Map/Map.component';

//constants
import { Constants } from '../../constants/Constants';

//base
import { BaseControlGroupComponent } from '../../baseclasses/BaseControlGroup.component';

@Component({
    selector: 'my-address',
    templateUrl: './Address.component.html',
    providers: [{ provide: BaseControlGroupComponent, useExisting: forwardRef(() => AddressComponent) }]
})
export class AddressComponent extends BaseControlGroupComponent {

    public address: ent.Address = new ent.Address();

    addressForm: FormGroup;

    @Output() public addressComponentChange: EventEmitter<ent.Address> = new EventEmitter();

    @Input() public disableAddressFormFields: boolean;

    @ViewChild(StateDropdownComponent) public stateDropdownComponent: StateDropdownComponent;
    @ViewChild(MapComponent) public mapComponent: MapComponent;


    @Input() public title: string;

    @Input() public showStreetNumber: boolean;
    @Input() public showStreetName: boolean;
    @Input() public showSupplemental: boolean;
    @Input() public showCity: boolean;
    @Input() public showState: boolean;
    @Input() public showPostalCode: boolean;
    @Input() public showPOBoxNumber: boolean;
    @Input() public showAddressLookup: boolean;


    @Input() public requireStreetNumber: boolean;
    @Input() public requireStreetName: boolean;
    @Input() public requireCity: boolean;
    @Input() public requireState: boolean;
    @Input() public requirePostalCode: boolean;
    @Input() public requirePOBoxNumber: boolean;


    setRequestInfo(request: ent.Request) {
        if (request.CustomerAddress && util.AddressUtil.isAddressPopulated(request.CustomerAddress)) {
            this.address = request.CustomerAddress;
            //console.info("Address.component.ts - setRequestInfo - this.address.AddressTypeID: " + this.address.AddressTypeID);
        }
        else if (request.EquipmentAddress && util.AddressUtil.isAddressPopulated(request.EquipmentAddress)) {
            this.address = request.EquipmentAddress;
            //console.info("Address.component.ts - setRequestInfo - this.address.AddressTypeID: " + this.address.AddressTypeID);
        }
    }
    setDates() { }

    constructor(fb: FormBuilder) {
        super();
        let group = {
            'streetNumber': '',
            'streetName': '',
            'city': '',
            'state': '',
            'hidState': '',
            'postalCode': '',
            'poBoxNumber': '',
            'supplemental': ''
        };

        this.addressForm = fb.group(group);

    }




    ngOnInit(): void {
        this.address.AddressTypeID = enums.AddressType.Customer;
        //console.info("Address.component.ts - ngOnInit - this.address.AddressTypeID: " + this.address.AddressTypeID);
        this.addressForm.controls.postalCode.setValidators(postalCodeValidator);

        if (this.requireStreetNumber) {
            this.addressForm.controls['streetNumber'].setValidators(Validators.required);
        }

        if (this.requireStreetName) {
            this.addressForm.controls['streetName'].setValidators(Validators.required);
        }

        if (this.requireCity) {
            this.addressForm.controls['city'].setValidators(Validators.required);
        }

        if (this.requireState) {
            this.addressForm.controls['state'].setValidators(dropDownValidator);
            this.addressForm.controls['hidState'].setValidators(hiddenDropDownValueValidator);
        }

        if (this.requirePostalCode) {
            this.addressForm.controls['postalCode'].setValidators([postalCodeValidator, Validators.required]);
        }

        if (this.requirePOBoxNumber) {
            this.addressForm.controls['poBoxNumber'].setValidators(Validators.required);
        }
    }

    stateSelected() {
        var val = true;
        var form = this.addressForm;
        if (form.controls.state.errors && form.controls.hidState.errors) {
            if (form.controls.state.errors.invalid && form.controls.hidState.errors.invalid) {
                val = false;
            }
        }
        return val;
    }

    stateChange(event: any) {
        this.address.StateID = event;
    }

    filteringAddress(event: any) {
        this.disableAddressFormFields = true;
    }

    filteredAddress(event: any) {
        this.disableAddressFormFields = false;
    }

    disableAddressInputs(): string {
        if (this.disableAddressFormFields) {
            return 'disabled';
        }
        return null;
    }

    stateLoadDone(event: any) {
        var selectedState = this.stateDropdownComponent.states.filter(x => x.Code.toUpperCase() == this.address.State.Code.toUpperCase())[0];
        if (selectedState) {
            this.stateDropdownComponent.value = selectedState.ID;
        }
    }

    addressChanged(address: ent.MyAddress) {



        this.address.StreetNumber = address.HouseNumber;
        this.address.StreetName = address.StreetName;
        this.address.City = address.City;
        this.address.PostalCode = address.PostalCode;
        this.address.Latitude = address.Lat;
        this.address.Longitude = address.Lng;
        this.address.State = {Code: address.State, ID: 0, Name: "", FullName: ""};

        if (address.State) {
            var selectedState = this.stateDropdownComponent.states.filter(x => x.Code.toUpperCase() == address.State.toUpperCase())[0];
            if (selectedState) {
                this.stateDropdownComponent.value = selectedState.ID;
            }
        }
        else {
            this.stateDropdownComponent.value = Constants._NONE;
        }
        

        if (this.mapComponent) {
            this.mapComponent.clearMarkers();
            this.mapComponent.addLocationToMap(address, null);
        }
        this.disableAddressFormFields = false;
    }

    streetNameChanged(){
        this.addressComponentChange.emit(this.address);
    }
    cityChanged(){
        this.addressComponentChange.emit(this.address);
    }

    stateChanged(){
        this.addressComponentChange.emit(this.address);
    }

    postalCodeChanged(){
        this.addressComponentChange.emit(this.address);
    }
}